// @flow
import React from 'react';
import {useDispatch} from 'react-redux';
import get from 'lodash/get';
import Tooltip, {TYPES} from 'common/componentsV2/Tooltip';
import './ImpersonateMenuItem.module.scss';
import {unimpersonate} from 'admin.users/store/actions';

type PropsTypes = {
  me: Object,
};
const ImpersonateMenuItem = React.memo(({me}: PropsTypes) => {
  const dispatch = useDispatch();

  const handleUnimpersonate = () => {
    // gotoState('unimpersonate');
    dispatch(unimpersonate()); // TODO: eli - to activate for Anodot Org uncomment and remove the gotoState
  };
  const firstName = get(me, 'firstName');
  const companyName = get(me, ['organization', 'name']);
  // TODO menny: replace this icon with new one
  const renderBody = (
    <div styleName="wrapper">
      <div styleName="tooltipTitle">Stop Impersonating</div>
      <div styleName="userInfo">{`${firstName} @ ${companyName}`}</div>
    </div>
  );

  return (
    <Tooltip content={renderBody} type={TYPES.NAV_BAR} placement="right" extraTtClass="impersonate" delay={50}>
      <div styleName="root" onClick={handleUnimpersonate}>
        <i className="icon icn-action24-stopimp" automation-id="reactStopImpersonatingIcon" />
      </div>
    </Tooltip>
  );
});

export default ImpersonateMenuItem;
